import React, { useEffect, useState } from 'react';
import { getProductions, getPartenaires, getForages } from '../services/api';

const Productions: React.FC = () => {
  const [productions, setProductions] = useState<any[]>([]);
  const [partenaires, setPartenaires] = useState<any[]>([]);
  const [forages, setForages] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState<any>({ annee: new Date().getFullYear().toString() });

  useEffect(() => {
    getPartenaires().then(r => setPartenaires(r.data));
    getForages().then(r => {
      const data = r.data.data || r.data;
      setForages(Array.isArray(data) ? data : []);
    });
  }, []);

  useEffect(() => {
    const params: Record<string, string> = { page: page.toString(), limit: '30' };
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v as string; });
    getProductions(params).then(r => {
      if (r.data.data) {
        setProductions(r.data.data);
        setTotal(r.data.total || 0);
        setTotalPages(r.data.totalPages || 1);
      } else {
        setProductions(Array.isArray(r.data) ? r.data : []);
        setTotal(Array.isArray(r.data) ? r.data.length : 0);
        setTotalPages(1);
      }
    }).catch(() => {});
  }, [page, filters]);

  const moisNoms = ['', 'Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'];

  return (
    <div>
      <h2 style={{ marginBottom: 20, color: '#333' }}>Productions ({total.toLocaleString('fr-FR')})</h2>

      <div className="filters-bar">
        <select value={filters.partenaire_id || ''} onChange={e => { setFilters({ ...filters, partenaire_id: e.target.value }); setPage(1); }}>
          <option value="">Tous les partenaires</option>
          {partenaires.map(p => <option key={p.id} value={p.id}>{p.libelle}</option>)}
        </select>
        <select value={filters.forage_id || ''} onChange={e => { setFilters({ ...filters, forage_id: e.target.value }); setPage(1); }}>
          <option value="">Tous les forages</option>
          {forages.map((f: any) => <option key={f.id} value={f.id}>{f.libelle}</option>)}
        </select>
        <select value={filters.annee || ''} onChange={e => { setFilters({ ...filters, annee: e.target.value }); setPage(1); }}>
          <option value="">Toutes les annees</option>
          {Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i).map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Forage</th>
              <th>Partenaire</th>
              <th>Mois</th>
              <th>Annee</th>
              <th>Production (m3)</th>
              <th>Cons. Elec (kW)</th>
              <th>Gasoil (L)</th>
              <th>Temps Pompage (H)</th>
            </tr>
          </thead>
          <tbody>
            {productions.map((p: any, i: number) => (
              <tr key={p.id || i}>
                <td>{p.forage || '-'}</td>
                <td>{p.partenaire || '-'}</td>
                <td>{moisNoms[p.mois] || p.mois}</td>
                <td>{p.annee}</td>
                <td>{p.production?.toLocaleString('fr-FR') || 0}</td>
                <td>{p.consommationelectrique?.toLocaleString('fr-FR') || 0}</td>
                <td>{p.gasoil?.toLocaleString('fr-FR') || 0}</td>
                <td>{p.tempspompage?.toLocaleString('fr-FR') || 0}</td>
              </tr>
            ))}
            {productions.length === 0 && (
              <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: '#999' }}>Aucune production trouvee</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Precedent</button>
        <span style={{ padding: '8px 14px', fontSize: 14 }}>Page {page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Suivant</button>
      </div>
    </div>
  );
};

export default Productions;
